import React, { useContext } from "react";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import styled from "styled-components";
import HelperService from "../../../services/HelperService";
import { useCart } from "../../../contexts/CartContext";
import { useAppContextNonNull } from "@contexts/AppContext";
import CatalogService from "@services/CatalogService";
import CurrenciesEnum from "@models/CurrenciesEnum";

type Props = {
    proceedToCheckout: () => void;
};

export const EcommerceRightSideHeader: React.FC<Props> = (props) => {
    const { supplierModel, vendorModel } = useAppContextNonNull();
    const { cart } = useCart();

    return (
        <EcommerceRightSideHeaderDiv>
            {cart?.Cart_Items?.length ? <OwButton title={"proceed_to_checkout"} fn={props.proceedToCheckout} /> : null}
            <div>
                <OwLabel title={"sub_total"} postText={":"} isBold={true} />{" "}
                {HelperService.formatCurrency({
                    value: cart?.sub_total || 0,
                    currency: vendorModel.Catalog?.currency_id
                        ? CatalogService.getCurrencyNameFromId(vendorModel.Catalog.currency_id)
                        : "USD",
                    precision: supplierModel.pricing_precision || 2,
                })}
            </div>
        </EcommerceRightSideHeaderDiv>
    );
};

const EcommerceRightSideHeaderDiv = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: center;
`;
